const STORAGE_KEY = 'printed_badges';

export const storage = {
    getPrintedToday() {
        try {
            const data = localStorage.getItem(STORAGE_KEY);
            if (!data) return {};

            const parsed = JSON.parse(data);
            const today = new Date().toDateString();

            // Clean old entries (not from today)
            const filtered = {};
            for (const [qrCode, entry] of Object.entries(parsed)) {
                if (entry.date === today) {
                    filtered[qrCode] = entry;
                }
            }

            // Update storage with cleaned data
            if (Object.keys(filtered).length !== Object.keys(parsed).length) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
            }

            return filtered;
        } catch (error) {
            console.error('Error reading printed badges:', error);
            return {};
        }
    },

    markAsPrinted(qrCode, name) {
        try {
            const printed = this.getPrintedToday();
            const today = new Date().toDateString();
            
            if (!printed[qrCode]) {
                printed[qrCode] = {
                    name,
                    date: today,
                    count: 1,
                    firstPrintedAt: new Date().toISOString()
                };
            } else {
                printed[qrCode].count += 1;
            }

            localStorage.setItem(STORAGE_KEY, JSON.stringify(printed));
            return printed[qrCode].count;
        } catch (error) {
            console.error('Error marking badge as printed:', error);
            return 1;
        }
    },

    // Event selection persistence
    saveSelectedEvent(eventId) {
        try {
            localStorage.setItem('selected_event', eventId);
        } catch (error) {
            console.error('Error saving selected event:', error);
        }
    },

    getSelectedEvent() {
        try {
            return localStorage.getItem('selected_event') || '';
        } catch (error) {
            console.error('Error reading selected event:', error);
            return '';
        }
    },

    clearAll() {
        localStorage.removeItem(STORAGE_KEY);
    }
};
